import { render, staticRenderFns } from "./addCadastralOvamModal.vue?vue&type=template&id=544e65fc&scoped=true"
import script from "./addCadastralOvamModal.vue?vue&type=script&lang=js"
export * from "./addCadastralOvamModal.vue?vue&type=script&lang=js"
import style0 from "./addCadastralOvamModal.vue?vue&type=style&index=0&id=544e65fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e65fc",
  null
  
)

export default component.exports